import * as RNLocalize from 'react-native-localize'
import { useEffect, useState } from 'react'

export const getLocaleState = () => ({
  locales: RNLocalize.getLocales(),
  bestAvailableLanguage: RNLocalize.findBestAvailableLanguage(['en', 'pt']),
})

export const useLocales = () => {
  const [state, setState] = useState(getLocaleState())
  useEffect(() => {
    const changeListener = () => {
      setState(getLocaleState())
    }
    RNLocalize.addEventListener('change', changeListener)
    return () => RNLocalize.removeEventListener('change', changeListener)
  })
  return state
}
